import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import CredentialsHelper from '../../utils/credentials-helper';
import { fetchAppData } from '../app/app.actions';
import routes from '../../utils/routes';
import Header from '../header/header';
import Footer from '../footer/footer';
import Notifications from '../notifications/notifications';
import AdminPagesContainer from './components/admin-pages/admin-pages';
import LoginRedirect from '../login/login-redirect';

class InternalPages extends React.Component {

    componentDidMount() {
        if (CredentialsHelper.isLoggedIn) {
            this.props.fetchAppData();
        }
    }

    render() {
        if (!CredentialsHelper.isLoggedIn) {
            return <LoginRedirect/>;
        }
        return (
            <div className='app-wrapper'>
                <Header {...this.props}/>
                <Switch>
                    <Route path={routes.ADMIN} component={AdminPagesContainer}/>
                    <Redirect to={routes.ADMIN}/>
                </Switch>
                <Footer/>
                <Notifications/>
            </div>
        );
    }
}

export default connect(
    null,
    dispatch => bindActionCreators({ fetchAppData }, dispatch),
)(InternalPages);



// WEBPACK FOOTER //
// ./src/components/internal-pages/internal-pages.js